import store from '@/store'
import { regionConfig, langConfig } from '@/config'

export default {
  getCountryList() {
    return store.getters['Common/getCountryListFromState']
  },
  findCountryId(id) {
    const list = this.getCountryList()
    return list.length == 0 ? null : list.find((ele) => ele.countryId === id)
  },
  findCountryName(name) {
    const list = this.getCountryList()
    return list.find((ele) => ele.name === name)
  },
  getJpCountrySelectBoxInfo() {
    const jp = '日本'
    return this.setCountryInfo(this.findCountryName(jp))
  },

  findRegionId(regionList, id) {
    return typeof regionList === 'undefined'
      ? null
      : regionList.find((ele) => ele.regionId === id)
  },
  findRegionName(regionList, name) {
    return typeof regionList === 'undefined'
      ? null
      : regionList.find((ele) => ele.name === name)
  },

  setCountryInfo(list) {
    return list
      ? { label: list.name, value: list.countryId }
      : { label: '', value: null }
  },
  getCountryIdInfo(id) {
    return this.setCountryInfo(this.findCountryId(id))
  },
  getCountryNameInfo(name) {
    const list = this.findCountryName(name)
    return this.setCountryInfo(list)
  },

  getRegionInfo(addressCountryId, regionId) {
    const countryInfo = this.findCountryId(addressCountryId)
    if (!countryInfo) {
      return { label: '', value: null }
    }

    const list = this.findRegionId(countryInfo.regionList, regionId)
    if (list) {
      return { label: list.name, value: list.regionId }
    }

    const isObject = regionId && typeof regionId === 'object'
    if (!countryInfo.showableRegionPulldown && !isObject) {
      return { label: regionId ? regionId : '', value: null }
    }

    return { label: '', value: null }
  },

  getRegionInfoByName(addressCountryId, regionName) {
    const countryInfo = this.findCountryId(addressCountryId)
    if (!countryInfo) {
      return { label: '', value: null }
    }

    const list = this.findRegionName(countryInfo.regionList, regionName)
    return list
      ? { label: list.name, value: list.regionId }
      : { label: '', value: null }
  },
  getRegionStrByLang(lang) {
    switch (lang) {
      case langConfig.LANG_JA:
        // 日本語は変換する意味ないのでメソッド使用前に弾いて
        return {}
      case langConfig.LANG_CN:
        return regionConfig.JPN_REGION_JA_TO_CN
    }
  }
}
